import React from 'react';
import { AditionInitialization, AditionTagPlacement } from '@vgn-medien-holding/vgn-fe-components';
import { getCookie } from 'cookies-next';
import { Oewa } from '@components/atoms/Oewa/Oewa';
import { Provider } from '@components/atoms/Provider/Provider';
import { Title } from '@components/atoms/Title';
import { providers } from '@utils/providers';
import { useTagManager } from '@lib/hooks/useTagManager';

// Provider
const ad_settings_Provider = {
  mobile_middle1: {
    id: 5256642,
    name: 'TVM_Mobile_Provider_MedRec_Cad',
    yieldLab: [],
    breakpoints: [0, 1, 2, 3],
  },
};

export function ProviderIndex() {
  useTagManager({
    event: 'metadata',
    loginStatus: 'nicht eingeloggt',
    seitentyp: 'Provider Übersicht',
    titel: 'Provider Übersicht',
    oewaSeitenkontingent: 'Service',
    oewaSubkontingent: 'Programmeundlokalfuehrer',
    oewaProfilingkontingent: 'TVProgramme',
    cookieAlert: getCookie('OptanonConsent'),
  });

  return (
    <div>
      <Oewa pageKey={'Service'} categoryKey={'Programmeundlokalfuehrer'} profileKey={'TVProgramme'} />
      <Title classProps={{ heading: 'text-xl lg:text-xl mb-6' }} level={1}>
        Provider
      </Title>
      <AditionInitialization data={{ ad_settings: ad_settings_Provider }} />
      <div className="grid grid-cols-fill-streaming-squares gap-4">
        {providers?.map((provider, index) => (
          <>
            {index % 8 === 0 && index !== 0 && (
              <AditionTagPlacement
                tag={ad_settings_Provider.mobile_middle1}
                classProps={{ root: 'col-span-full mx-auto md:hidden' }}
              />
            )}
            <div key={provider.id}>
              <Provider key={provider.id} provider={provider} style="box" />
            </div>
          </>
        ))}
      </div>
    </div>
  );
}

export async function providerIndexSsrLogic() {
  return {
    props: {
      slug: 'index',
    },
  };
}
